import { UserButton } from "@clerk/clerk-react";
import { Link } from "react-router-dom";
import leblanc from "../images/leblanc.png";
import { useAuth } from "../contexts/AuthContext";

/**
 * SearchHeader component with role-based Admin link visibility
 * Feature: 001-user-role-management (T042)
 */
export function SearchHeader() {
  const { isAdmin } = useAuth();

  return (
    <header className="absolute top-0 w-full p-4 flex items-center justify-between">
      <Link
        to="https://www.leblanc-associes.com/"
        className="flex items-center gap-2"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span className="text-sm font-bold text-white/70">Propulsé par</span>
        <img src={leblanc} alt="LeBlanc" className="h-8 w-auto" />
      </Link>
      <div className="flex items-center gap-4">
        {/* Only show Admin link for users with admin role - Feature: 001-user-role-management (T042) */}
        {isAdmin && (
          <Link
            to="/admin"
            className="text-sm font-bold text-white hover:text-blue-200 transition-colors"
          >
            Admin
          </Link>
        )}
        <UserButton
          appearance={{
            elements: {
              avatarBox: "h-8 w-8",
            },
          }}
        />
      </div>
    </header>
  );
}
